import styled from 'styled-components';
import { ControlButton } from '../ControlButton';
import { ComponentProps } from 'react';

export const StyledMuteButton = styled(ControlButton)<ComponentProps<'button'>>`
  background-color: var(--color);
`;
